{
  "name": "IncivilitesMobile",
  "version": "2.0.1",
  "author": "Digiwin",
  "homepage": "https://digiwin.com/",
  "description": "Incivilité Mobilité",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test --watch=false",
    "lint": "ng lint",
    "sonar": "sonar-scanner",
    "test:coverage": "ng test --watch=false --coverage"
  },
  "engines": {
    "node": ">=16",
    "npm": ">=8"
  },
  "config": {
    "ionic_generate_source_map": "true"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "~22.2.4",
    "@angular/compiler": "~22.2.4",
    "@angular/core": "~22.2.4",
    "@angular/forms": "~22.2.4",
    "@angular/platform-browser": "~22.2.4",
    "@angular/platform-browser-dynamic": "~22.2.4",
    "@angular/router": "~22.2.4",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@ionic/angular": "^9.0.0",
    "chart.js": "^3.4.0",
    "core-js": "^3.41.0",
    "file-type-mime": "^0.4.6",
    "html2canvas": "^1.4.1",
    "jspdf": "^3.0.1",
    "karma-spec-reporter": "0.0.36",
    "lodash": "^4.17.21",
    "ng-circle-progress": "1.7.1",
    "ng2-charts": "^3.1.2",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/architect": "~0.2202.5",
    "@angular-devkit/core": "~22.2.5",
    "@angular-devkit/schematics": "~22.2.5",
    "@angular-eslint/builder": "^22.6.0",
    "@angular/build": "22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "~22.2.4",
    "@angular/language-service": "~22.2.4",
    "@eslint/js": "^9.39.0",
    "@ionic/angular-toolkit": "~13.0.0",
    "@types/node": "^22.14.1",
    "@vitest/coverage-v8": "~4.0.18",
    "angular-eslint": "^22.6.0",
    "cerialize": "^0.1.18",
    "eslint": "^9.39.0",
    "jsdom": "^27.0.0",
    "prettier": "^3.5.3",
    "sonarqube-scanner": "^4.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.1",
    "vitest": "~4.0.18"
  }
}
